<template>
  <div class="button-options-config-dialog" :key="ids.elementInLayoutId">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="抽屉设置"
        name="5"
        v-if="isDrawer"
      >
        <div class="data-item mb8">
          <el-checkbox v-model="openDrawer">显示抽屉</el-checkbox>
        </div>
        <div class="data-item">
          <cx-label-slider
            class="rect-active-slider"
            label="触发方式"
            :value.sync="drawerTriggerType"
            :options="activeTypeOptions"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "button-options-config",
  components: {},
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      collapseActiveNames: ["5"],
      activeNames: ["5"],
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      // 触发方式
      activeTypeOptions: [
        { value: "mousemove", title: "悬浮" },
        { value: "click", title: "点击" }
      ]
    }
  },
  computed: {
    isDrawer() {
      return this.options.pluginName?.includes("drawerPlugin") || false
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isBigScreen() {
      if (this.request_prefix === "bigScreen") {
        return true
      } else {
        return false
      }
    },
    openDrawer: {
      get() {
        return this.options.hasOwnProperty("openDrawer") ? this.options.openDrawer : false
      },
      set(newVal) {
        // 广播抽屉状态
        this.$eventBus.$emit("control-drawer", {
          openDrawer: newVal,
          sourceId: this.options.drawerPath
        })
        this.$changeOptionsEV(newVal, "openDrawer", false)
      }
    },
    drawerTriggerType: {
      get() {
        return this.options.drawerTriggerType || "mousemove"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerTriggerType", false)
      }
    }
  }
}
</script>

<style scoped>
.rect-active-slider {
  padding: 12px;
  background: rgba(251, 252, 253, 1);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
}
</style>
